import React from 'react';
import ReactDOM from 'react-dom/client';

import { Root } from '@/ui/Root';

import { PdfRoot } from './ui/PdfRoot';
import { ScoreCardsRoot } from './ui/ScoreCardsRoot';

const pathname = window.location.pathname;
const isPdfRoute = pathname.startsWith('/pdf');
const isScoreCardsRoute = pathname.startsWith('/score-cards');

const App = isPdfRoute ? (
  <PdfRoot />
) : isScoreCardsRoute ? (
  <ScoreCardsRoot />
) : (
  <Root />
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>{App}</React.StrictMode>,
);
